import React from 'react';
import PropTypes from 'prop-types';

const WhatsAppFilterPopup = ({ filterOptions, onApply, onClose }) => {
  const handleShowChange = (value) => {
    const newFilters = { ...filterOptions, show: value };
    onApply(newFilters);
  };

  const handleSortChange = (value) => {
    const newFilters = { ...filterOptions, sortBy: value };
    onApply(newFilters);
  };

  // Updated CheckIcon to match Figma design exactly
  const CheckIcon = ({ checked }) => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      {checked ? (
        <>
          <circle cx="7" cy="7" r="7" fill="#0BA9E0" />
          <path d="M4.375 7L6.125 8.75L9.625 5.25" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </>
      ) : (
        <circle cx="7" cy="7" r="6.25" stroke="#344054" strokeWidth="1.5" />
      )}
    </svg>
  );

  // Updated FilterOption to match Figma design exactly
  const FilterOption = ({ label, value, isSelected, onClick }) => (
    <div
      onClick={onClick}
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '10px',
        padding: '3px 10px 3px 16px',
        cursor: 'pointer',
        backgroundColor: 'white',
        width: '212px',
        height: 'auto'
      }}
    >
      <CheckIcon checked={isSelected} />
      <span style={{
        fontFamily: 'Poppins',
        fontWeight: '500',
        fontSize: '14px',
        lineHeight: '1.5em',
        letterSpacing: '0.25%',
        color: '#344054',
        flex: 1
      }}>
        {label}
      </span>
    </div>
  );

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={onClose}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.1)',
          zIndex: 999
        }}
      />

      {/* Popup */}
      <div style={{
        position: 'absolute',
        top: '70px',
        right: '15px',
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'stretch',
        width: '212px',
        backgroundColor: '#FFFFFF',
        borderRadius: '16px',
        boxShadow: '0px 3.75px 11px 0px rgba(0, 0, 0, 0.19), 0px 0.5px 5px 0px rgba(0, 0, 0, 0.04)'
      }}>
        {/* Show Section */}
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: '10px',
          padding: '10px 10px 3px 16px',
          width: '212px',
          backgroundColor: 'white',
          borderRadius: '5px 5px 0px 0px'
        }}>
          <div style={{
            fontFamily: 'Poppins',
            fontWeight: '400',
            fontSize: '12px',
            lineHeight: '1.5em',
            color: '#737C8A'
          }}>
            Show
          </div>
        </div>

        {/* Show Options */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: 'white'
        }}>
          <FilterOption
            label="Assigned to me"
            value="assigned"
            isSelected={filterOptions.show === 'assigned'}
            onClick={() => handleShowChange('assigned')}
          />

          <FilterOption
            label="All conversation"
            value="all"
            isSelected={filterOptions.show === 'all'}
            onClick={() => handleShowChange('all')}
          />

          <FilterOption
            label="Open"
            value="open"
            isSelected={filterOptions.show === 'open'}
            onClick={() => handleShowChange('open')}
          />

          <FilterOption
            label="Close"
            value="close"
            isSelected={filterOptions.show === 'close'}
            onClick={() => handleShowChange('close')}
          />

          <FilterOption
            label="Replied"
            value="replied"
            isSelected={filterOptions.show === 'replied'}
            onClick={() => handleShowChange('replied')}
          />

          <FilterOption
            label="Unreplied"
            value="unreplied"
            isSelected={filterOptions.show === 'unreplied'}
            onClick={() => handleShowChange('unreplied')}
          />
        </div>

        {/* Sort By Section */}
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: '10px',
          padding: '10px 10px 3px 16px',
          width: '212px',
          backgroundColor: 'white'
        }}>
          <div style={{
            fontFamily: 'Poppins',
            fontWeight: '400',
            fontSize: '12px',
            lineHeight: '1.5em',
            color: '#737C8A'
          }}>
            Sort by
          </div>
        </div>

        {/* Sort Options */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: 'white'
        }}>
          <FilterOption
            label="Newest"
            value="newest"
            isSelected={filterOptions.sortBy === 'newest'}
            onClick={() => handleSortChange('newest')}
          />

          <div style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '10px',
            padding: '3px 10px 10px 16px',
            width: '212px',
            backgroundColor: 'white',
            borderRadius: '0px 0px 5px 5px',
            cursor: 'pointer'
          }}
          onClick={() => handleSortChange('oldest')}
          >
            <CheckIcon checked={filterOptions.sortBy === 'oldest'} />
            <span style={{
                fontFamily: 'Poppins',
                fontWeight: '500',
                fontSize: '14px',
                lineHeight: '1.5em',
                letterSpacing: '0.25%',
                color: '#344054',
                flex: 1
              }}>
              Oldest
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

WhatsAppFilterPopup.propTypes = {
  filterOptions: PropTypes.shape({
    show: PropTypes.oneOf(['assigned', 'all', 'open', 'close', 'replied', 'unreplied']).isRequired,
    sortBy: PropTypes.oneOf(['newest', 'oldest']).isRequired
  }).isRequired,
  onApply: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

export default WhatsAppFilterPopup;
